<script>
  import { createEventDispatcher } from 'svelte'

  import MoreMenu from './widgets/more-menu.svelte'

  import Toasts from './toast'


  export let title
  export let moreMenuItems

  const dispatch = createEventDispatcher()

  const back = function () {
    dispatch('back')
  }
</script>

<header>
  <button class="iconButton" on:click={back} title="Back">
    <svg class="icon" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18">
      </path>
    </svg>
  </button>
  {#if title}
    <h4>{title}</h4>
  {/if}
  <div class="spacer"></div>
  {#if moreMenuItems && moreMenuItems.length}
    <MoreMenu menuItems={moreMenuItems} position="belowLeft" />
  {/if}
</header>
<main>
  <slot />
  <Toasts />
</main>
<slot name="controls" />

<style>
  header h4 {
    align-self: center;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
